import { lazy } from "react";
import Loadable from "app/components/Loadable";

const LoanActivity = Loadable(lazy(() => import("./LoanActivity")));
const LoanActivityDetail = Loadable(lazy(() => import("./LoanActivityDetail")));
const LoanActivityAdd = Loadable(lazy(() => import("./LoanActivityAdd")));

const loanactivityRoute = [
    { path: "/loanactivity", element: <LoanActivity /> },
    { path: "/loanactivity/add", element: <LoanActivityAdd /> },
    { path: "/loan-activity/:loanId", element: <LoanActivityDetail /> },
];
export default loanactivityRoute;
